import { mergePropsClassName } from '@liquorice/utils';
import Shim, { ShimProps } from '../Shim';
import * as styles from './BlockContainer.css';

export type BlockContainerShimProps = ShimProps & { isActive?: boolean };

export const BlockContainerShim = ({ isActive, ...props }: BlockContainerShimProps) => {
  return isActive && <Shim {...mergePropsClassName(props, styles.shim)} />;
};
